import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "@/hooks/useAnalytics";

/**
 * Component that tracks page views on route changes
 * Should be placed inside the Router component but outside of Routes
 */
export function PageViewTracker() {
  const location = useLocation();
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    // Track page view whenever the path changes
    const pageTitles: Record<string, string> = {
      "/": "Landing Page",
      "/dashboard": "Dashboard",
      "/billing": "Billing & Usage",
      "/cli-auth": "CLI Authentication",
    };

    const pageTitle = pageTitles[location.pathname] || "Page";

    // Track the page view
    trackPageView(location.pathname, pageTitle);
  }, [location.pathname, trackPageView]);

  // This component doesn't render anything
  return null;
}

export default PageViewTracker;
